import React, { useEffect } from "react";
import { CircleMarker, MapContainer, TileLayer, Tooltip, useMap } from "react-leaflet";
import { BASEMAP_URL, LABELS_URL } from "../radar/radarConfig";

const FlyTo = ({ target }) => {
  const map = useMap();
  useEffect(() => {
    if (target) map.flyTo([target.lat, target.lon], Math.max(map.getZoom(), 7), { duration: 0.6 });
  }, [map, target]);
  return null;
};

// Every HazCam station on a dark map; clicking a dot plays it in-site.
export const SkycamNetworkMap = ({ stations, selected, onSelect, userLocation }) => (
  <MapContainer center={[37.5, -92]} zoom={4} minZoom={3} maxZoom={12} zoomControl attributionControl={false} className="sd-radar-map h-full w-full bg-[#02040c]" preferCanvas>
    <TileLayer url={BASEMAP_URL} />
    <TileLayer url={LABELS_URL} />
    <FlyTo target={selected ? { lat: selected.lat, lon: selected.lon } : userLocation} />
    {userLocation && <CircleMarker center={[userLocation.lat, userLocation.lon]} radius={7} pathOptions={{ color: "#fff", weight: 2, fillColor: "#22d3ee", fillOpacity: 1 }} />}
    {stations.filter((station) => station.lat != null).map((station) => {
      const isSelected = selected?.id === station.id;
      return (
        <CircleMarker
          key={station.id}
          center={[station.lat, station.lon]}
          radius={isSelected ? 7 : 5}
          pathOptions={{ color: isSelected ? "#fff" : "#020617", weight: 1.5, fillColor: !station.online ? "#475569" : isSelected ? "#22d3ee" : "#ef4444", fillOpacity: 0.95 }}
          eventHandlers={{ click: () => onSelect(station) }}
        >
          <Tooltip direction="top" offset={[0, -6]} className="sd-leaflet-tooltip">{station.name}{station.online ? "" : " · offline"}</Tooltip>
        </CircleMarker>
      );
    })}
  </MapContainer>
);

export default SkycamNetworkMap;
